module.exports = __webpack_public_path__ + "44edc1b04e4b2e9598a1e255d9b0a1ef.jpg";